import Utils from '../utils/Utils.js';

export default class Modal {
  constructor(element) {
    this.element = element;
    this.modalId = this.element.dataset.modalId;
    this.modalElement = null;
    this.closeButtons = [];

    this.init();
  }

  init() {
    this.element.addEventListener('click', this.open.bind(this));

    this.close = this.close.bind(this);
  }

  updateContent() {
    if (this.modalId == 'tpl-modal-tool') {
      this.modalElement.innerHTML = Utils.parseTemplate(
        this.modalElement.innerHTML,
        {
          title: this.element.dataset.modalTitle,
        }
      );
    }
  }

  open(event) {
    event.preventDefault();
    this.appendModal();
  }

  close(event) {
    if (event.key && event.key !== 'Escape') return;

    const modalElement = this.getModalElement(event);
    const closeButtons = modalElement ? [...modalElement.querySelectorAll('.js-close')] : this.closeButtons;

    if (modalElement) {
      modalElement.classList.add('is-closing');
    }

    document.documentElement.classList.remove('modal-is-active');
    closeButtons.forEach((button) => {
      button.removeEventListener('click', this.close);
    });
    document.removeEventListener('keyup', this.close);

    window.setTimeout(() => {
      this.destroy(modalElement);
    }, 300);

    if (this.modalElement === modalElement) {
      this.modalElement = null;
      this.closeButtons = [];
    }
  }

  getModalElement(event) {
    if (event && event.currentTarget && event.currentTarget.closest) {
      return event.currentTarget.closest('.modal');
    }

    return this.modalElement;
  }

  destroy(modalElement = this.modalElement) {
    if (modalElement && modalElement.parentElement) {
      modalElement.parentElement.removeChild(modalElement);
    }
  }

  appendModal() {
    const template = document.querySelector(`#${this.modalId}`);

    // We valide that a template with this ID actually exists
    if (template) {
      this.modalElement = template.content.firstElementChild.cloneNode(true);

      // Update modal content
      this.updateContent();

      // We append the modal to the DOM
      document.body.appendChild(this.modalElement);

      // This forces the browser to redraw (and execute from A to Z the css transition)
      this.element.getBoundingClientRect();
      document.documentElement.classList.add('modal-is-active');

      // We add behavior to our close button
      this.closeButtons = [...this.modalElement.querySelectorAll('.js-close')];
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', this.close);
      });

      document.addEventListener('keyup', this.close);
    } else {
      console.error(`Le <template> avec le id ${this.modalId} n'existe pas`);
    }
  }
}
